import { render, staticRenderFns } from "./CzContent.vue?vue&type=template&id=8daafc8e&scoped=true&"
import script from "./CzContent.vue?vue&type=script&lang=js&"
export * from "./CzContent.vue?vue&type=script&lang=js&"
import style0 from "./CzContent.vue?vue&type=style&index=0&id=8daafc8e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8daafc8e",
  null
  
)

export default component.exports